import "../styles/_reset.css"
import "../styles/common.css"
import Header from "../elements/header/header"
import Footer from "../elements/footer/footer"
import { ParallaxProvider } from "react-scroll-parallax"
//import gql from "graphql-tag"
//import { getAssetUrl } from "../dotcms"
import Head from "next/head"
/*
const query = gql`
  {
    pageCommonCollection(limit: 1) {
      brightLogo {
        ...embeddedFilePath
      }
      darkLogo {
        ...embeddedFilePath
      }
      copyrightStatement
      termsAndCondsUrl
      privacyPolicyUrl
    }
  }

  fragment embeddedFilePath on Fileasset {
    fileAsset {
      versionPath
    }
  }
`

export function fetchingData(client) {
  return client.query({ query }).then(result => {
    let commonData = result.data.pageCommonCollection[0]

    return {
      brightLogo: getAssetUrl(commonData.brightLogo),
      darkLogo: getAssetUrl(commonData.darkLogo),
      copyrightStatement: commonData.copyrightStatement,
      termsAndPolicyUrl: commonData.termsAndPolicyUrl,
    }
  })
}
*/
class Layout extends React.Component {
  constructor(props) {
    super(props)
    this.handleScroll = this.handleScroll.bind(this)
    this.state = {
      colorType: "",
      heightType: "",
    }
  }
  componentDidMount() {
    if (this.props.page != "error") {
      window.addEventListener("load", this.handleScroll, true)
      window.addEventListener("scroll", this.handleScroll, true)
    }
  }
  componentWillUnmount() {
    if (this.props.page != "error") {
      window.removeEventListener("load", this.handleScroll, true)
      window.removeEventListener("scroll", this.handleScroll, true)
    }
  }

  handleScroll() {
    var scrollTop = Math.max(
      window.pageYOffset,
      document.documentElement.scrollTop,
      document.body.scrollTop
    )
    if (document.getElementsByClassName("kv").length) {
      var anchorLevel =
        document.getElementsByClassName("kv")[0].offsetHeight -
        document.getElementsByTagName("header")[0].offsetHeight
    } else {
      var anchorLevel = 50
    }
    if (scrollTop > 30) {
      this.setState({
        heightType: "minimize",
      })
    } else {
      this.setState({
        heightType: "",
      })
    }
    if (scrollTop > anchorLevel && this.props.page != "staticHead") {
      this.setState({
        colorType: "colored",
      })
    } else {
      this.setState({
        colorType: "",
      })
    }
    if (this.props.page == "tnc") {
      if (scrollTop > 173 && window.innerWidth > 991) {
        document.getElementsByClassName("menu-wrap")[0].style.position = "fixed"
        document.getElementsByClassName("menu-wrap")[0].style.top = "143px"
      } else {
        document.getElementsByClassName("menu-wrap")[0].style.position =
          "relative"
        document.getElementsByClassName("menu-wrap")[0].style.top = "auto"
      }
    }
  }
  render() {
    return (
      <div>
        <Head>
          <title>{this.props.meta.title}</title>
          <meta name="title" content={this.props.meta.title} />
          <meta name="description" content={this.props.meta.description} />
          <meta name="image" property="og:image" content={process.env.DOMAIN_ROOT + "/c2-social-share.png"} />
          <meta name="og:title" content={this.props.meta.title} />
          <meta name="og:description" content={this.props.meta.description} />
          <meta
            data-hid="og:image"
            name="og:image"
            content={process.env.DOMAIN_ROOT + "/c2-social-share.png"}
          />
          <link rel="icon" href="/c2-favicon.ico" />
        </Head>
        <Header
          page={this.props.page}
          data={this.props.data}
          heightType={this.state.heightType}
          colorType={this.state.colorType}
          currentPagePath={this.props.currentPagePath}
        />
        <div className="content" key={this.props.currentPagePath}>
          <ParallaxProvider>{this.props.children}</ParallaxProvider>
        </div>
        <Footer
          data={this.props.data}
          pagePath={this.props.currentPagePath}
          footerPos={this.props.footerPos}
          externalUrl={this.props.externalUrl}
        />
      </div>
    )
  }
}
export default Layout
